class CartDrawer extends HTMLElement {
  constructor() {
    super();
    this.overlay = this.querySelector('#CartDrawer-Overlay');
    this.closeButtons = this.querySelectorAll('.drawer__close');
    this.drawerInner = this.querySelector('.drawer__inner');

    // Attach event listeners
    this.overlay?.addEventListener('click', this.close.bind(this));
    this.closeButtons.forEach(btn => btn.addEventListener('click', this.close.bind(this)));

    // Handle cart icon click
    const cartIcon = document.querySelector('[data-cart-drawer-toggle]');
    if (cartIcon) {
      cartIcon.addEventListener('click', e => {
        e.preventDefault();
        this.open();
      });
    }
  }

  open() {
    this.classList.add('active');
    document.body.classList.add('drawer-open');
    if (this.overlay) this.overlay.style.display = 'block';
  }

  close() {
    this.classList.remove('active');
    document.body.classList.remove('drawer-open');
    if (this.overlay) this.overlay.style.display = 'none';
  }
}

customElements.define('cart-drawer', CartDrawer);
